import applianceRuleApi from '@/api/appliance-rule'
import store from '@/store'
import form from './form'

const state = {
  list: [],
  loading: false,
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    commit('SET_LOADING', true)

    return applianceRuleApi.getAll()
      .then(({ data }) => commit('SET_LIST', data))
      .catch(() => store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch'))
      .finally(() => commit('SET_LOADING', false))
  },
  delete({ dispatch }, id) {
    return applianceRuleApi.delete(id)
      .then(() => {
        store.dispatch('message/success', 'PROMOTION.success')

        return dispatch('fetchList')
      })
      .catch(error => {
        store.dispatch('message/error', 'PROMOTION.removeFailure')
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, data) {
    state.list = data
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
}

const modules = {
  form,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
}
